import React from "react";
import SkladkaLogoSvg from "./SkladkaLogo.svg?react";

interface SkladkaLogoProps {
  size?: number;
}

const DEFAULT_SIZE = 24;

const SkladkaLogo: React.FC<SkladkaLogoProps> = ({ size = DEFAULT_SIZE }) => (
  <SkladkaLogoSvg width={size} height={size} aria-hidden="true" />
);

export default SkladkaLogo;
